/**
 * V2's feature vector, derived entirely from `Signal` fields that are also
 * computable from historical OHLCV candles alone (no order flow, no Kalshi
 * price) so every feature here can be honestly validated in a backtest, not
 * just asserted live. Order names matter: `toFeatureVector` and
 * `FEATURE_NAMES` must stay in lockstep, since a fitted `LogisticModel`'s
 * weights are positional.
 */
export const FEATURE_NAMES = [
    'trend1',
    'trend5',
    'trend15',
    'emaSpreadPct',
    'emaAccelerationPct',
    'rsi',
    'macdHistPct',
    'atrPct',
    'realizedVol',
    'ret1',
    'ret5',
    'ret15',
    'norm5',
    'norm15',
    'distanceAtr',
    'volumeRatio',
    'hourSin',
    'hourCos',
];
function cyclicalHour(roundStartMs) {
    const hour = new Date(roundStartMs).getUTCHours() + new Date(roundStartMs).getUTCMinutes() / 60;
    const angle = (2 * Math.PI * hour) / 24;
    return { sin: Math.sin(angle), cos: Math.cos(angle) };
}
/** Builds a V2 feature vector, in `FEATURE_NAMES` order, from a computed V1 `Signal`. */
export function toFeatureVector({ signal, macdHist }) {
    const { sin, cos } = cyclicalHour(signal.roundStartMs);
    const norm5 = signal.atrPct ? signal.ret5 / signal.atrPct : 0;
    const norm15 = signal.atrPct ? signal.ret15 / signal.atrPct : 0;
    return [
        signal.trend1,
        signal.trend5,
        signal.trend15,
        signal.price ? ((signal.ema9 - signal.ema21) / signal.price) * 100 : 0,
        signal.price ? (signal.emaAcceleration / signal.price) * 100 : 0,
        signal.rsi,
        signal.price ? (macdHist / signal.price) * 100 : 0,
        signal.atrPct,
        signal.realizedVol,
        signal.ret1,
        signal.ret5,
        signal.ret15,
        norm5,
        norm15,
        signal.distanceAtr,
        signal.volumeRatio,
        sin,
        cos,
    ];
}
//# sourceMappingURL=features.js.map